import { useEffect } from 'react';
import styled from 'styled-components';

import { So5LeaderboardType } from '@sorare/core/src/__generated__/globalTypes';
import { ConversionCreditCampaignBanner } from '@sorare/core/src/components/conversionCredit/ConversionCreditCampaignBanner';
import { LeaguesBlock } from '@sorare/core/src/components/landing/LeaguesBlock';
import { NewOtherSports } from '@sorare/core/src/components/landing/NewOtherSports';
import { useIsLoggedIn } from '@sorare/core/src/hooks/auth/useIsLoggedIn';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';

import useFontFaceObserver from '@sorare/use-font-face-observer';
import { Community } from 'components/landing/shared/Community';
import { FAQ } from 'components/landing/shared/FAQ';

import { Experience } from './Experience';
import { Hero } from './Hero';
import { Prizes } from './Prizes';

const DarkBackground = styled.div`
  overflow: hidden;
  position: relative;
  background-color: black;
  color: var(--c-static-neutral-100);
`;

const FootballPublicHome = () => {
  const isLoggedIn = useIsLoggedIn();
  const track = useEvents();
  const fontStatus = useFontFaceObserver(
    [{ family: 'DrukWide-Super', weight: 'bold' }],
    { timeout: 1000 }
  );

  useEffect(() => {
    if (!isLoggedIn) {
      track('View Homepage Disconnected', {
        landing_variant: 'Football',
      });
    }
  }, [isLoggedIn, track]);

  if (fontStatus === 'initial') return null; // allow rendering without the right font after the timeout

  return (
    <DarkBackground>
      <ConversionCreditCampaignBanner />
      <Hero />
      <LeaguesBlock />
      <Experience />
      <Prizes />
      <Community
        leaderboards={[
          So5LeaderboardType.IN_SEASON_CHAMPIONS_LIMITED,
          So5LeaderboardType.IN_SEASON_CHALLENGERS_UNIQUE,
          So5LeaderboardType.IN_SEASON_CONTENDERS_RARE,
        ]}
      />
      <NewOtherSports />
      <FAQ />
    </DarkBackground>
  );
};

export default FootballPublicHome;
